module.exports = __webpack_public_path__ + "img/icon99.ff23ce40.png";